// Set ağacı satır ⋯ menüsü klavye kararı (TODO-KPI-120, WAI-ARIA menu button): saf — bileşen yalnız
// sonucu uygular. Dönüş: odaklanacak öğe indeksi | "activate" (odaktaki öğeyi seç) | "close"
// (menüyü kapat, odak tetikleyiciye) | null (tuşu işleme).

export function setRowMenuKey(
  key: string,
  index: number,
  count: number,
): number | "activate" | "close" | null {
  if (key === "Escape") return "close";
  if (count <= 0) return null;
  const cur = index < 0 || index >= count ? 0 : index;
  switch (key) {
    case "ArrowDown":
      return index < 0 ? 0 : (cur + 1) % count;
    case "ArrowUp":
      return index < 0 ? count - 1 : (cur - 1 + count) % count;
    case "Home":
      return 0;
    case "End":
      return count - 1;
    case "Enter":
    case " ":
      return index < 0 ? null : "activate";
    default:
      return null;
  }
}
